/*!
 * @copyright	Copyright (C) 2016 Piotr Konieczny. All rights reserved.
 * @license		GNU General Public License version 2 or later; see LICENSE.txt
 */

/**
 * Finder handler
 *
 * Probably better idea to use HTML5 datalist, but it's not supported on Safari 10
 * @see http://blog.teamtreehouse.com/creating-autocomplete-dropdowns-datalist-element
 *
 * @see https://getuikit.com/docs/search.html
 * @see https://getuikit.com/docs/autocomplete.html
 */
window.WgTemplate.PkgFinder = (function() {

    'use strict';

    /**
     * Attempt to reafactor inline mod_finder scripts
     *
     * @param {HTMLElement} element - Target element
     * @param {Object} options - Options
     */
    function PkgFinder(element, options) {

        this.name = 'PkgFinder'

        /** @type {jQuery} */
        this.$element = jQuery(element);

        /** @type {Object} */
        this.options = (options || {});

        /** @type {Object} HashMap of common elements */
        this.$els = {};

        /** @type {Object} */
        this.extensionSettings = this.$element.data('wgPkgFinder');
        // UIkit.Utils.options(this.$element.attr('data-uk-pkg-finder'))

        this.$els.form = jQuery('[data-wg-pkg-finder-searchform="' + this.extensionSettings.id + '"]');
        this.$els.input = jQuery('[data-wg-pkg-finder-searchword="' + this.extensionSettings.id + '"]');
        this.$els.advanced = jQuery('[data-wg-pkg-finder-advanced="' + this.extensionSettings.id + '"]');

        this.defaultValue = this.$els.input.val();

        // If the current value equals the default value clear it.
        // @note: Used placeholder

        // If the current value is empty, set the previous value
        this.$els.input.on('blur', jQuery.proxy(this.onInputBlur, this));

        this.$els.form.on('submit', jQuery.proxy(this.onFormSubmit, this));

        // Module wrapper
        this.$els.moduleChrome = jQuery('[data-wg-mod-wrapper="' + this.extensionSettings.id + '"]');

        if (this.extensionSettings.autosuggest) {

            // Init instanly
            this.createAutosuggest();
            /*
            if (!this.$els.moduleChrome) {
                this.createAutosuggest();
            // Only on show/ hide
            } else {
                this.$els.moduleChrome.on('show.uk.dropdown', jQuery.proxy(this.createAutosuggest, this));
                this.$els.moduleChrome.on('hide.uk.dropdown', jQuery.proxy(this.destroyAutosuggest, this));
            }
            */
        }

        /*
        // Page loaded with some value, open the shit
        if (this.defaultValue) {
            // Open after it's probably initialized
            // UIkit.on('domready.uk.dom', function() {
            window.setTimeout(jQuery.proxy(function() {
                UIkit.dropdown(this.$els.moduleChrome).show();
            }, this), 200);
        }
        */
    }

    /**
     * Create new instance for jQuery.each
     *
     * @param {integer} index
     * @param {HTMLElement} element
     *
     * @return {PkgFinder}
     *
     * @this {WgTemplate}
     */
    PkgFinder.getInstance = function(index, element) {

        this.registerExtension(new PkgFinder(element, this.options));
    };

    /**
     * Default autosuggest options
     *
     * @type {Object}
     *
     * @see https://github.com/devbridge/jQuery-Autocomplete
     */
    PkgFinder.autosuggestOptions = {
        // Ajax Settings
        type: 'POST',
        paramName: 'q',
        deferRequestBy: 500,
        // Configuration settings
        minChars: 1,
        // Presentation settings
        maxHeight: 400,
        width: 300,
        zIndex: 9999
    };

    /**
     * This segment of code sets up the autocompleter.
     *
     * @return {PkgFinder}
     */
    PkgFinder.prototype.createAutosuggest = function() {

        this.$els.input.autocomplete(jQuery.extend({
            // serviceUrl: this.options.baseUri + '/index.php?option=com_finder&task=suggestions.suggest&format=json&tmpl=component'
            serviceUrl: this.extensionSettings.url,
            onSelect: jQuery.proxy(this.onAutocompleteSelect, this)
        }, PkgFinder.autosuggestOptions));

        return this;
    };

    /**
     * Destroy autosuggest
     */
    PkgFinder.prototype.destroyAutosuggest = function() {

        this.$els.input.autocomplete('dispose');

        return this;
    };

    /**
     * Input blurred
     *
     * @param {jQuery.Event} event
     */
    PkgFinder.prototype.onInputBlur = function(event) {

        var $el = jQuery(event.target);

        if (!$el.val()) {
            $el.val(this.defaultValue);
        }
    };

    /**
     * Form submitted
     *
     * @param {jQuery.Event}
     */
    PkgFinder.prototype.onFormSubmit = function(event) {

        event.stopPropagation();

        // Disabled select boxes with no value selected
        this.$els.advanced.find('select').each(function(i, el) {
            var $el = jQuery(el);

            if (!$el.val()) {
                $el.prop('disabled', true);
            }
        });
    };

    /**
     * Autocomplete selection
     *
     * @param {Object} suggestion
     * @param {string} suggestion.data
     * @param {string} suggestion.value
     */
    PkgFinder.prototype.onAutocompleteSelect = function(suggestion) {

        // Trigger form submit event (warning: on search page these are auto-selected)
        // this.$els.form.trigger('submit');
    };

    return PkgFinder;

}(jQuery));
